import React, { useEffect, useState } from 'react'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import eventbanner from '../stickySide/images/EventBanner.jpg';
import axios from 'axios';
import customamount from '../stickySide/images/customamount.jpeg';
import ev2 from '../stickySide/images/eventpaymrnt.jpeg';
import evbg from '../stickySide/images/evbg2.jpeg';

interface chapterstruc{
  id:number;
  name:string;
}

interface UserStructure {
  profile: string;
  id: number;
  name: string;
  email: string;
  delete: number;
  role:string;
  designation:string;
  company_name:string;
  Facebook:string;
  Linkedin:string;
  point:number;
  number:number;
}
const EventRegister = () => {
      const api = process.env.REACT_APP_API_URL as string;
       const [isExpressModalOpen, setExpressModalOpen] = useState<boolean>(false);
        const [isVisitorModalOpen, setVisitorModalOpen] = useState<boolean>(false);
        const [isResistationModalOpen, setRegistationModalOpen] = useState<boolean>(false);
      
      
        const [selectedFacility, setSelectedFacility] = useState<string | null>("800");
        const [selectedTshirtSize, setselectedTshirtSize] = useState<string | null>(null);
        const [selectedFile, setSelectedFile] = useState<String | null>(null); 
      const [userDetails, setuserDetails] = useState<UserStructure[]>([]);
      const[chapterdata, setChapterdata] = useState<chapterstruc[]>([]);
      

       useEffect(() => {
            const fetchData = async () => {
              try {
                const response = await axios.get<UserStructure[]>(
                  `${api}/auth/allusersinfo`
                );
        
                setuserDetails(response.data);
              } catch (error) {
                console.error("user Not Found:", error);
              }
            };
        
            fetchData();
          }, []);
        const handleTshirtSizeChange = (e:any) => {
          setselectedTshirtSize(e.target.value);
        };
      
        const handleFacilityChange = (e:any) => {
          setSelectedFacility(e.target.value);
        };
        
        const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          if (event.target.files && event.target.files[0]) {
            // setSelectedFile(event.target.files[0]);
          }
      
          const file = event.target.files?.[0] || null;
          setSelectedFile(file ? file.name : null);
        };
      
  useEffect (()=>{
    const fetch = async ()=>{
        try{

            const response = await axios.get(`${api}/auth/chapter`);
            setChapterdata(response.data.data);

        }
        catch(error){
   
            //console.log('error fetching point', error);
        }
    }
    fetch();
},[])
const handleRegistrationSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
  event.preventDefault();

  // Example form data collection
  const formData = new FormData(event.currentTarget);
  const data = {
    name: formData.get('name'),
    chaptId: formData.get('chaptId'),
    businessName: formData.get('businessName'),
    category: formData.get('category'),
    mobile: formData.get('mobile'),
  transitionId: formData.get('transitionId'),
  facility: selectedFacility,
  address:formData.get('address'),
  city: formData.get('city'),
  role: formData.get('role'),
  deals: formData.get('deals'),
  pincode: formData.get('pincode'),
  suggestionQuestion:formData.get('suggestionQuestion'),
  email:formData.get('email'),
  whatsappNumber:formData.get('whatappnumber'),
  profile:selectedFile,
  tSize: selectedTshirtSize,





    
  };

  // console.log('data , ',data);

  try {
    const response = await axios.post(`${api}/auth/event-registration`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.status >= 200 && response.status < 300) {
      alert('Event Registration form submitted successfully' );
      window.location.reload();
      // console.log('Visitor Registration form submitted successfully');
      setRegistationModalOpen(false)
    } else {
      console.error('Failed to submit Visitor Registration form:', response.data.message || 'Unknown error');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error('Error submitting Visitor Registration form:', error.response?.data?.message || error.message);
    } else {
      console.error('Unexpected error:', error);
    }
  }

  setVisitorModalOpen(false);
};
  return (
    <div> 
        <Header/>
        <div className=" bg-[#1E2A3A] flex justify-center py-14">
             <div className="bg-white p-6 rounded-lg lg:w-[50%] w-[100%] h-[94%] overflow-y-auto">
              <img src = {evbg} className='w-[96%]' />
              <h2 className="text-xl font-bold mb-4">Event Registration Form</h2>
              <form
  onSubmit={handleRegistrationSubmit}
  className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-md grid grid-cols-1 gap-6 md:grid-cols-2"
>
  {/* Full Name */}
  <label className="block">
    <span className="block font-medium text-gray-700">Full Name:</span>
    <input
      type="text"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      placeholder="Enter Your Name"
      name="name"
      required
    />
  </label>

  {/* Email */}
  <label className="block">
    <span className="block font-medium text-gray-700">Email Id:</span>
    <input
      type="email"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      name="email"
      placeholder="Enter Email Address"
      required
    />
  </label>

  {/* Mobile */}
  <label className="block">
    <span className="block font-medium text-gray-700">Mobile number:</span>
    <input
      type="tel"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      name="mobile"
      placeholder="Enter Mobile Number"
      required
    />
  </label>

  {/* City */}
  <label className="block">
    <span className="block font-medium text-gray-700">City:</span>
    <input
      type="text"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      name="city"
      placeholder="Enter City Name"
      required
    />
  </label>

  {/* Pincode */}
  <label className="block">
    <span className="block font-medium text-gray-700">Pincode:</span>
    <input
      type="text"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      name="pincode"
      placeholder="Enter Pincode"
      required
    />
  </label>

  {/* Business Name */}
  <label className="block">
    <span className="block font-medium text-gray-700">Business / Organization Name:</span>
    <input
      type="text"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      name="businessName"
      placeholder="Enter Organization Name"
      required
    />
  </label>

  {/* Category */}
  <label className="block">
    <span className="block font-medium text-gray-700">Business Classification / Category:</span>
    <input
      type="text"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      name="category"
      placeholder="Enter Classification Name"
      required
    />
  </label>

  {/* Profile Upload */}
  <label className="block">
    <span className="block font-medium text-gray-700">Upload Payment</span>
    <input
      type="file"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      name="profile"
      onChange={handleFileChange}
    />
  </label>

  {/* Paid Amount */}
  <label className="block md:col-span-2">
    <span className="block font-medium text-gray-700">Paid Amount:</span>
    <div className="flex flex-col sm:flex-row gap-4 mt-2">
      <label className="flex items-center">
        <input
          type="radio"
          name="facility"
          value="800"
          onChange={handleFacilityChange}
          checked={selectedFacility === '800'}
          className="form-radio h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
        />
        <span className="ml-2 text-gray-700">Rs. 800 /-</span>
      </label>

      <label className="flex items-center">
        <input
          type="radio"
          name="facility"
          value="1000"
          onChange={handleFacilityChange}
          checked={selectedFacility === '1000'}
          className="form-radio h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
        />
        <span className="ml-2 text-gray-700">Rs. 1000 /-</span>
      </label>

      <label className="flex items-center">
        <input
          type="radio"
          name="facility"
          value="RMBJaipurMember"
          onChange={handleFacilityChange}
          checked={selectedFacility === 'RMBJaipurMember'}
          className="form-radio h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
        />
        <span className="ml-2 text-gray-700">RMB Jaipur Member</span>
      </label>
    </div>
  </label>

  {/* Facility Images */}
  {selectedFacility === '800' && (
    <div className="mt-4 flex justify-center md:col-span-2">
      <img
        src={ev2}
        alt="First Facility"
        className="w-[190px] rounded-lg shadow-md"
      />
    </div>
  )}

  {selectedFacility === '1000' && (
    <div className="mt-4 flex justify-center md:col-span-2">
      <img
        src={ev2}
        alt="Second Facility"
        className="w-[190px] rounded-lg shadow-md"
      />
    </div>
  )}

  {/* Transition ID */}
  <label className="block md:col-span-2">
    <span className="block font-medium text-gray-700">Transition / UTR Id:</span>
    <input
      type="text"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      name="transitionId"
      placeholder="Enter Your Transition / UTR Id"
    
    />
  </label>

  {/* Buttons */}
  <div className="flex flex-col sm:flex-row gap-2 mt-6 md:col-span-2">
    <button
      className="bg-blue-600 hover:bg-blue-700 text-white rounded text-lg font-medium h-[46px] px-4"
      type="submit"
    >
      Submit
    </button>
    <button
      className="bg-red-600 hover:bg-red-700 text-white rounded text-lg font-medium h-[46px] px-4"
      type="button"
      onClick={() => setRegistationModalOpen(false)}
    >
      Close
    </button>
  </div>
</form>



            </div>
          </div>
  <Footer/>
  </div>
  )
}

export default EventRegister